import { post, get } from "./http";
import common from './constants';

let basic = common.interfacePath.serverTestUrl;
basic += '';
console.log(`${basic}/msg/waitSize`)

const transactionApi = {
    // 往来书确认
    getTradeConfirmFileList: params => { return post(`/member/getTradeConfirmFileList`, params); },
    //质检单查询中的物料查询
    getProductList: params => { return post(`/product/listMaterial`, params); },
    //根据批次+物料信,查询质检单信息
    getQualityCert: params => { return post(`/product/getQualityCert`, params); },
    //客户投诉列表
    getlistComplaint: params => { return post(`/complaint/listComplaint`, params) },
    //投诉新增
    saveComplaint: params => { return post(`/complaint/saveComplaint`, params) },
    //客户投诉详情页
    getdetail: params => { return post(`/complaint/getComplaintDetail`, params) },
    // 客户投诉结案单下载
    closureComplaint: params => { return post(`/complaint/closureComplaint`, params) },
    //订单评价
    saveEvaluation: params => { return post(`/order/evaluation/saveEvaluation`, params); }, 
    //订单评价查看
    getEvaluation: params => { return get(`/order/evaluation/getEvaluation`, { params }); },
     //    资金查询
    getFundsList: params => { return post(`/payment/listTransFlowByPage`, params); },
     //ERP余额接口
    getbalance: params => { return post(`/Company/listCompanyPayHistory`, params); },
    //ERP统计
    getStatistics: params => { return post(`/Company/listCompanyCreditAmount`, params); },
    // 资质列表
    listQualification: params => { return post(`/member/listQualification`, params); },
    //新增/修改资质
    getQualificationDetail: params => { return post(`/member/getQualificationDetail`, params); },  
    //提货
    getPickupData: params => { return post(`/bill/selectBill`, params); }, 
    batchListCodeSet: params => { return post(`/product/batchListCodeSet`, params); },
    //提货 撤销
    removePickup: params => { return post(`/order/cancelBill`, params); },
    //提货 申请
    submitPickupData: params => { return post(`/order/submitBill`, params); }, 
    // 提货 物流
    gettrack: params => { return post(`/logistic/track`, params) },
    //公司信息
    getCompanyDetail: params => { return post(`/company/getCompanyDetail`, params); },
    //发票查询
    getInvoiceList: params => { return post(`/order/queryInvoice`, params); },
    //  客存查询
    getCustomerList: params => { return post(`/order/queryBuyerStockCus`, params) },

    //消息列表
    messageList: params => { return post(`/msg/list`, params); },
    //消息列表删除
    getDel:params => { return post(`/msg/del`, params)},
    // 消息列表设为已读
    getTrue:params => { return post(`/msg/updateStatue`,params); },

    //消息列表初始化
    messageInit: params => { return post(`/msg/init`, params); },
    //更新消息状态
    updateMsgStatue: params => { return post(`/msg/updateStatue`, params); },
    //我的消息（未读接口）
    getMessage: params => { return post(`/msg/waitSize`, params); },
    // 承运商列表接口
    listCarriersByPage: params => { return post(`/carrier/listCarriersByPage`, params); },
    // 承运商详情页
    getCysdetile: params => { return post(`/carrier/getCarrierDetail`, params) },
    // 我的关注
    getListAttention: params => { return post(`/merchant/selectFollow`, params); },  
    // 提货人管理
    listBuyerConsignee: params => { return post(`/member/listBuyerConsignee`, params); },
    // 车船管理列表
    listBuyerTransport: params => { return post(`/member/listBuyerTransport`, params); },
    // 车船管理详情
    getCarDetail: params => { return post(`/member/getVehicleDetail`, params); },
    // 专家服务列表
    getlistBuyerExpertConsult: params => { return post(`/expert/listBuyerExpertConsult`, params) }, 
    //专家服务详情
    getExpertConsultDetail: params => { return post(`/expert/getExpertConsultDetail`, params) }, 

    delAttentionData: params => { return post(`${basic}/delete/follow`, params); },  //协议

    commodity: params=> {return post(`${basic}/list/commodity`, params);},//点击我的关注取到id
    //协议
    getAgreement: params => {
        return post(`/merchant/listAgreement`, params);
    },

};
export default transactionApi;